import { defineStore } from 'pinia';

export const useModalsStore = defineStore('modals', {
    state: () => ({
        current: null,
        payload: null
    }),

    getters: {
        currentModal: state => ({
            name: state.current,
            payload: state.payload,
        })
    },
    actions: {
        setModalName(name) {
            this.current = name
        },
        setModalPayload(payload) {
            this.payload = payload
        },
        reset() {
            this.current = null
            this.payload = null
        }
    }
});